import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import useCheckMobileScreen from '../../../hooks/useWidth';
import SelectionForm from '../Form/SelectionForm';

const SelectForm = () => {
    const history = useHistory();
    const { id, formId, clinicId } = useParams();
    const [selectedForm, setSelectedForm] = useState();
    const allForms = useSelector((state) => state.dynamicForms.allForms);
    const isMobile = useCheckMobileScreen();

    useEffect(() => {
        if (formId && allForms) {
            const found = allForms.find((val) => val.name === formId);
            setSelectedForm(found);
        } else if (!formId && allForms && !isMobile) {
            const firstFormName = allForms[0]?.name;
            history.replace(`/${clinicId}/patient/${id}/forms/comparison/${firstFormName}`);
        }
    }, [allForms, formId, isMobile]);
    // useEffect(() => {
    //     if (!allForms) {
    //         const namespace = getNamespace();
    //         if (namespace) {
    //             dispatch(getForms(namespace));
    //         }
    //     }
    // }, []);
    const handleSelectForm = (formId) => {
        if (formId) {
            history.replace(`/${clinicId}/patient/${id}/forms/comparison/${formId}`);
        }
    };

    return (
        <>
            <SelectionForm
                optionsLabel="title"
                formTitle={selectedForm}
                options={allForms?.map((val) => ({
                    id: val.name,
                    title: val.title
                }))}
                handleSelectForm={(name) => {
                    handleSelectForm(name);
                }}
            />
        </>
    );
};
export default SelectForm;
